import React from "react";
import SectionContainer from "../shared/SectionContainer";
import "./ValueSummary.css";

type ValueSummaryProps = {
  id?: string;

  title: string;
  bullets: string[];

  /** Optional illustration element (SVG/img/component). */
  illustration?: React.ReactNode;

  /** Wrap in a card surface (default true) */
  card?: boolean;
};

const ValueSummary: React.FC<ValueSummaryProps> = ({
  id,
  title,
  bullets,
  illustration,
  card = true,
}) => {
  return (
    <SectionContainer id={id} card={card} className="ocf-pi-vs">
      <div className="ocf-pi-vs-grid">
        <div className="ocf-pi-vs-copy">
          <div className="ocf-pi-vs-title">{title}</div>
          <ul className="ocf-pi-vs-list">
            {bullets.map((b, i) => (
              <li key={`${b}-${i}`}>{b}</li>
            ))}
          </ul>
        </div>

        {illustration && (
          <div className="ocf-pi-vs-visual" aria-hidden>
            {illustration}
          </div>
        )}
      </div>
    </SectionContainer>
  );
};

export default ValueSummary;
